if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.blockId = this.dataset.blockId;
        this.block = this.closest(`[data-id="${this.blockId}"]`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        if (!this.mql) {
          this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        }
        this.init();
      }

      disconnectedCallback() {
        if (this.mql) {
          this.mql.onchange = null;
          this.mql = null;
        }
        if (this.enableSlider) {
          this.destroySlider();
        }
      }

      init() {
        if (this.mql) {
          this.mql.onchange = this.init.bind(this);
        }
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const gapRaw = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap').trim();
        let spaceBetween = 0;
        if (gapRaw) {
          if (gapRaw.endsWith('px')) {
            spaceBetween = parseFloat(gapRaw) || 0;
          } else if (gapRaw.endsWith('rem')) {
            const rem = parseFloat(gapRaw) || 0;
            const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
            spaceBetween = rem * rootPx;
          } else {
            const n = parseFloat(gapRaw.replace(/rem|px/gi, ''));
            spaceBetween = Number.isFinite(n) ? n * 10 : 0;
          }
        }

        const paginationEl = this.block?.querySelector(this.selectors.pagination);
        this.sliderOptions = {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.block?.querySelector(this.selectors.nextEl),
            prevEl: this.block?.querySelector(this.selectors.prevEl),
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                type: this.paginationType,
              }
            : false,
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
              slidesPerGroup: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
              slidesPerGroup: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
              slidesPerGroup: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          watchOverflow: true,
          roundLengths: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
        this.fixQuickviewDuplicate();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        const controls = this.block.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}
